
import { get, put, post, del } from './connection'

const API_BASE_URL = process.env.REACT_APP_API_URL;
const candidateApi = {

    createCandidate: async (requestData) => {
        try {
            const response = await post(`/candidate/add-candidate`, requestData.formData,'form');
            // debugger
           return response;
        } catch (error) {
            throw new Error("Error while creating new candidate");
        }
    }, 
    
    deleteCandidate: async (id) => {
        try {
            const response = await del(`/candidate/delete-candidate/${id}`);
            return response;
        } catch (error) {
            throw new Error("Error while deleting candidate details");
        }
    },

    updateCandidateDetails: async (requestData) => {
        try {
            console.log("Request Data:", requestData); // Check if it has 'id' and 'formData'
            console.log("Request ID:", requestData.id);
            console.log("Request FormData:", requestData.formData);
    
            // Ensure the ID is available before making the PUT request
            if (!requestData.id) {
                throw new Error("ID is required for update.");
            }
    
            const response = await put(
                `/candidate/edit-candidate/${requestData.id}`, 
                requestData.formData,
                'form'
            );
            
            return response;
        } catch (error) {
            throw new Error("Error while updating candidate details: " + error.message);
        }
    },
    
    
    
    getAllCandidateDetails: async (queryString) => {
        try {
            return get("/candidate/get-all-candidates"+ queryString);
        } catch (error) {
            throw new Error("Error while fetching job details");
        }
    },  

    getLastCandidateActivity: async (candidateId, jobId) => {
        try {
            return get(`/candidate/get_last_candidate_activity/${candidateId}/${jobId}`);
        } catch (error) {
            throw new Error("Error while fetching last candidate activity");
        }
    },

    
    getCandidateById: async (id) => {
        try {        
            return get(`/candidate/get-candidate-by-id/${id}`);
        } catch (error) {

            throw new Error("Error while selecting job detail");
        }
    },

    insertCommentForCandidate: async (requestData) => {
        try {        
            return await post(`/candidate/add-comment-for-candidate`, requestData);  
        } catch (error) {

            throw new Error("Error while inserting comments");
        }
    },
    getCommentsForCandidate: async (id) => {
        try {      
            // const A=  await get(`/candidate/get-comments-by-candidateid/${id}`);
            // debugger
            // return A;
            return await get(`/candidate/get-comments-by-candidateid/${id}`);
        } catch (error) {
            throw new Error("Error while selecting comments");
        }
    },
    insertNegotiationHistory: async (requestData) => {
        try {
            const response = await post(`/candidate/add-negotiation-history`, requestData);
           return response;
        } catch (error) {
            throw new Error("Error while creating negotiation history");
        }
    }, 
    getCandidatePackageAndNegotiationHistory: async (candidateid,companyId) => {
        try {      
            return await get(`/candidate/get-candidate-package-and-negotiation-history/${candidateid}/${companyId}`);
        } catch (error) {
            throw new Error("Error while selecting comments");
        }
    },
    getCandidateActivityDetails: async (candidateId, jobIdid) => {
        try {            
            return get(`/candidate/get_candidate-activities/${candidateId}/${jobIdid}`);
        } catch (error) {

            throw new Error("Error while selecting candidate activity details");
        }
    },
    getJobsByCandidate: async (id) => {
        try {      
            // const A=  await get(`/candidate/get-comments-by-candidateid/${id}`);
            // debugger
            // return A;
            return await get(`/candidate/get_jobs_by_candidateid/${id}`);
        } catch (error) {
            throw new Error("Error while selecting comments");
        }
    },
    createCandidateActivity: async (requestData) => {
        try {
            const response = await post(`/candidate/add-candidate-activity`, requestData);
           return response;
        } catch (error) {
            throw new Error("Error while creating candidate activity");
        }
    }, 

    insertAssessmentWithRatings: async (requestData) => {
        try {
            const response = await post(`/candidate/add-assessment_with_ratings`, requestData);
           return response;
        } catch (error) {
            throw new Error("Error while creating candidate assessment");
        }
    }, 
    fetchAssessmentWithRatings: async (candidateId, jobId) => {
        try {            
            return get(`/candidate/get_assessment_with_ratings/${candidateId}/${jobId}`);
        } catch (error) {

            throw new Error("Error while selecting candidate assessment details");
        }
    },
    updateAssessmentWithRatings: async (requestData) => {
        try {
            if (!requestData.assessmentId) {
                throw new Error("ID is required for update.");
            }
            const response = await put(`/candidate/edit-assessment/`+ requestData.assessmentId, requestData);            
            return response;
        } catch (error) {
            throw new Error("Error while updating assessment details: " + error.message);
        }
    },
    getAssessmentByAssessmentId: async (assessmentId) => {
        try {      
            return await get(`/candidate/get_assessment_by_assessmentid/${assessmentId}`);
        } catch (error) {
            throw new Error("Error while selecting assessment");
        }
    },

    getAddProfileCandidateDetails: async (queryString) => {
        try {
            return get("/candidate/get_add_profile_candidates"+ queryString);
        } catch (error) {
            throw new Error("Error while fetching job details");
        }
    },  

};

export default candidateApi;